import React from 'react';

import { useIntl } from 'react-intl';

import SectionMessage from '@atlaskit/section-message';

import { messages } from './messages';

export const ChatErrorBanner = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<SectionMessage
			title={formatMessage(messages.conversationNotFoundTitle)}
			appearance="information"
		>
			{formatMessage(messages.conversationNotFoundDescription)}
		</SectionMessage>
	);
};
